"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceWith = exports.replace = void 0;

var _map = require("../map/map");

var _isMatch = require("../is-match/is-match");

var _type = require("../type/type");

/**
 * Replace substring in string
 *
 * @param  {string}  oldString  The old string
 * @param  {string}  newString  The new string
 *
 * @return {string}
 */
var replaceString = function replaceString(oldString, newString) {
  return function (source) {
    return "".replace.call(source, oldString, newString);
  };
};
/**
 * Replace element in array (shallow equal)
 *
 * @param  {mixed}  oldElm  The old elm
 * @param  {mixed}  newElm  The new elm
 *
 * @return {Array}
 */


var replaceArray = function replaceArray(oldElm, newElm) {
  return function (source) {
    var result = [];

    for (var i = 0, length = source.length - 1; i <= length; i++) {
      if (oldElm === source[i]) {
        result.push(newElm);
      } else {
        result.push(source[i]);
      }
    }

    return result;
  };
};
/**
 * Replace substring if source is string, replace element (shallow equal) if
 * source is Array
 *
 * @param {string|mixed}  oldElm  To be cloned
 * @param {string|mixed}  newElm  Copy of this object.
 * @param {string|Array}  source  Source array
 *
 * @return {string|Array}
 *
 * @tag String,Array
 * @signature (oldElm: string|mixed, newElm: string|mixed) => (source: Array): Array
 *
 */


var replace = function replace(oldElm, newElm) {
  return function (source) {
    var sourceType = (0, _type.type)(source);
    var byType = {
      String: replaceString,
      Array: replaceArray
    };
    return byType[sourceType](oldElm, newElm)(source);
  };
};
/**
 * Replace object element in array using filter object
 *
 * @tag Array
 * @signature (filter: Obj, replace: Obj|Function) => (source: Obj[]): Obj[]
 *
 * @param  {Object}    filter    Filter object to match against each element
 * @param  {Object}    newValue  Object to replace matching elements
 * @param  {Object[]}  source    Source array
 *
 * @return {Array}
 *
 * @example
 * replaceWith(
 *  {id: 2},
 *  {id: 2, title: "boss", isBoss: true}
 *  )([
 *    {id: 2, title:"minion"}
 *    {id: 3, title:"minion"}
 *  ])
 * // => [
 * //   {id: 2, title:"boss", isBoss: true},
 * //   {id: 3, title:"minion"}
 * // ]
 *
 * replaceWith({ id: 2 }, item => ({
 *   ...item,
 *   content: ["new", "updated", "field"],
 * }))([
 *   { id: 1, name: "foo", content: [] },
 *   { id: 2, name: "bar", content: [] },
 * ])
 * // [
 * //   { id: 1, name: "foo", content: [] },
 * //   { id: 2, name: "bar", content: ["new", "updated", "field"] },
 * // ],
 */


exports.replace = replace;

var replaceWith = function replaceWith(filter, newValue) {
  return (0, _map.map)(function (item) {
    return (0, _isMatch.isMatch)(filter)(item) ? typeof newValue === "function" ? newValue(item) : newValue : item;
  });
};

exports.replaceWith = replaceWith;